var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{class:['payment-status', _vm.statusClass]},[_vm._v(" "+_vm._s(_vm.statusDescription)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }